import {
  DOWNLOAD_CONFIG_EXCEL,
  DOWNLOAD_CONFIG_EXCEL_SUCCESS,
  DOWNLOAD_CONFIG_EXCEL_ERROR,
  DOWNLOAD_CONFIG_EXCEL_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DownloadExcel = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_CONFIG_EXCEL:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_CONFIG_EXCEL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_CONFIG_EXCEL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DOWNLOAD_CONFIG_EXCEL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DownloadExcel;
